import { render, staticRenderFns } from "./ListOrgs.vue?vue&type=template&id=70de1ed8&scoped=true&"
import script from "./ListOrgs.vue?vue&type=script&lang=js&"
export * from "./ListOrgs.vue?vue&type=script&lang=js&"
import style0 from "./ListOrgs.vue?vue&type=style&index=0&id=70de1ed8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70de1ed8",
  null
  
)

export default component.exports